import { assistantRoutes, assistantNavigationItems } from "./router";
export class AssistantModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[AssistantModule] Registered");
        return {
            id: "assistant",
            name: "Assistant Module",
            version: "1.0.0",
        };
    }
    getRoutes() {
        return assistantRoutes;
    }
    getNavigationItems() {
        return assistantNavigationItems;
    }
    getComponent() {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[AssistantModule] Unregistered");
        this.contracts = null;
    }
}
export default new AssistantModule();
